
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { artistsService } from '../../services/artists/artists.service';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
// Action Object for ArtistsCatalog. Import the types from artists/types.js and Invoke Actions from the Vuex Host Components.
import router from '../../../../router';
import { releaseService } from '../../services/releases/releases.services';
const NavTabModule = getNavTabModule(types.CatalogArtistsDetails, 'artistDetails');


export const artistsCatalogActions = {
  async [types.ArtistsCatalogData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const artistsCatalogData = await HttpClient.mergeRequests([
      artistsService.getArtists()
    ]);
    console.log("artistsCatalogData",artistsCatalogData,getters.artistsList.length);
    if(getters.startRow==0){
      commit(types.ArtistsCatalogData.SET.ALL, artistsCatalogData);
    }
    
  },

  async [types.ArtistsCatalogListData.INSERT.SINGLE]({commit,getters,dispatch},payload){
    
    
    console.log("PL",payload)
    const newArtist=await artistsService.newArtist(payload)


    
    //const releaseDetails=await releaseService.getReleasesDetails(release.data.release_id)
    
    // getters.releasesCatalogData.releases.push(releaseDetails.data.release)
  
    
    commit(types.ArtistsCatalogListData.SET.ALL,
            { 
              artist:newArtist.data.all_artists,
              action:"INSERT"
            }
          );
    
    console.log("ADD RELEASE",newArtist)
  },

  async [types.ArtistsCatalogListData.DELETE.SINGLE]({commit,getters,dispatch},payload){
    const nextArtistList=await artistsService.removeArtists(payload.label_artist_id);

    commit(types.ArtistsCatalogListData.DELETE.SINGLE,payload);

    
  },

  async [types.ArtistsCatalogListData.SET.ALL]({commit,getters,dispatch},payload){
    const nextArtistList=await artistsService.retrieveArtistsPage(getters.startRow+100);

    commit(types.ArtistsCatalogListData.SET.ALL,
      { 
        artist:nextArtistList.data.all_artists,
        action:"SET"
      }
    );

    
  },

  async [types.CatalogArtistsDetails.FETCH.SINGLE]({commit,getters,dispatch},payload){
    
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, artist, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'label_artist_id';
    const itemName = 'artist';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'artistDetails';
    const DetailsAction = types.CatalogArtistsDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req

    const detailsResponse = await HttpClient.mergeRequests([
      artistsService.artistDetails(artist.label_artist_id),
      artistsService.artistDetailsTabOverview(artist.label_artist_id),
      artistsService.artistDetailsTabText(artist.label_artist_id),
      artistsService.artistDetailsTabBookings(artist.label_artist_id),
      artistsService.artistDetailsTabMetadata(artist.label_artist_id),
      artistsService.showMetadata(artist.label_artist_id),
    ]);

    console.log("DETaIlS OF RESponSE",detailsResponse);


    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, artist) => {
      return {
        ...artist,
        ...detailsResponse,
        loading: false,
      }
    })
  },

  ...NavTabModule.implementActions(
    'label_artist_id',
    'catalog_artists/label_artist_id/tab',
    'catalog_artists',
    () => router,
    'catalog',
    (value, key) => {
      
      console.log("KEY::",key,"value::",value)
      return {
        title: (value?.artist?.artist_name) ? value?.artist?.artist_name:key,
        full_title: (value?.artist?.artist_name) ? value?.artist?.artist_name:key,
      }
    }
  ),

  async [types.CatalogArtistsDetails.UPDATE.SINGLE]({commit,getters,dispatch },payload){
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
   

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name ,value , item} = payload
    const { artist } = item;
    const { label_artist_id } = artist;


    console.log("types.CatalogArtistsDetails.UPDATE.SINGLE", name ,value ,item)
    NavTabHelper.updateSingleNavTabDetails(label_artist_id, (artistDetailsObject) => {
      return {
        artist: {
          ...artistDetailsObject.artist,
          [name]: value,
        }
      }
    });
    const modifiedRelease=await MHTTPCL.modifyJSON('label_artist_id',item.label_artist_id,name,value,'l_artists')


  



  },

  async [types.ArtistRelatedContacts.SET.ALL]({commit,getters,dispatch}, {
    contact_relations,
    external_table,
    external_id,
  }){
      const NavTabHelper = NavTabModule.Helper(dispatch, getters);
      NavTabHelper.updateSingleNavTabDetails(external_id, (_, artistDetailsObject) => {
      return {
        ...artistDetailsObject,
        contact_relations: contact_relations
      };
    })
  },

  async [types.ArtistRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT",payload)
    const { contact, artist } = payload;
    const { label_artist_id } = artist;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
      
        contact_relations: artistDetailsObject.contact_relations.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });
    console.log("WERET",contact_relation_id)
    
    const deletedContact=await releaseService.deleteContactRelation(contact_relation_id)


  },


  async [types.DefaultCredit.INSERT.SINGLE]({ commit, getters, dispatch }, payload){
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { artist } = payload;
    const { label_artist_id } = artist;

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: true,
      }
    });

    const newCreditList=await artistsService.addDefaultCredit(label_artist_id,payload.type,payload.name,payload.percentage)
    
    console.log("Log: newRelatedLink", newCreditList);




      NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
        return {
          default_credits: newCreditList.data.default_credits
        };
      })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: false,
      }
    });
  },

  async [types.DefaultCredit.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, artist } = payload;
    const { label_artist_id } = artist;
    const { track_info_id }=item;

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
     
        default_credits: artistDetailsObject.default_credits.
          filter(e => e.track_info_id != track_info_id)
      }
    })

    const deletedLinks = await artistsService.removeDefaultCredit(track_info_id);
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.CatalogRelease.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
  
    const { relation_id, artist } = payload;
    const { label_artist_id } = artist;
  

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
     
        related_releases: artistDetailsObject.related_releases.
          filter(e => e.relation_id != relation_id)
      }
    })

    const deletedLinks = await artistsService.removeRelatedReleaseToArtist(relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.CatalogRelease.INSERT.SINGLE]({ commit, getters, dispatch }, payload){
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("PAYLOAD",payload)
    const { artist,releases,release_ids } = payload;
    const { label_artist_id } = artist;

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: true,
      }
    });

   
  
    const newReleaseList=await artistsService.addRelatedReleasesToArtist(label_artist_id,releases,release_ids);
    console.log("Log: newRelatedLink", newReleaseList);




      NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
        return {
          related_releases: newReleaseList.data.related_releases,
          
        };
      })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: false,
      }
    });
  },

  async [types.ArtistBookingArtist.INSERT.SINGLE]({ commit, getters, dispatch }, payload){
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("PAYLOAD",payload)
    const { artist,artist_id } = payload;
    const { label_artist_id } = artist;

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: true,
      }
    });

    const selectedArtist=await artistsService.addRrelatedBookingArtist(artist_id,label_artist_id)
    const newArtistsList=await artistsService.loadRelatedBookingArtists(label_artist_id)
    const releatedBooking=await artistsService.loadRelatedBookings(label_artist_id);
    console.log("Log: newRelatedLink", newArtistsList);




      NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
        return {
          related_booking_artists: newArtistsList.data.related_booking_artists
        };
      })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        loading: false,
      }
    });
  },

  async [types.ArtistBookingArtist.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
  
    const { relation_id, artist } = payload;
    const { label_artist_id } = artist;
  

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
     
        related_booking_artists: artistDetailsObject.related_booking_artists.
          filter(e => e.relation_id != relation_id)
      }
    })

    const deletedLinks = await artistsService.removeRelatedBookingArtist(relation_id);
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },


  async [types.SET_ARTIST_PRODUCT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const label_artist_id=externalId
    console.log("FILES",files,externalId)
    NavTabHelper.setSingleNavTabDetails(label_artist_id, (_, artistDetailsObject) => {
     
      return {
        ...artistDetailsObject,
        files: files,
      }
    });
  },

  async [types.SET_ARTIST_ARTWORK]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("ARTWORK PAYLOAD",payload);
    const { selectedArtistDetails, file, artworkKey } = payload;
    const { file_id } = file;
    const { artist } = selectedArtistDetails;
    const { label_artist_id } = artist;


    NavTabHelper.updateSingleNavTabDetails(label_artist_id, (artistDetailsObject) => {
      return {        
        [artworkKey]: file.file_link,
        
        // artist: {
        //   ...artistDetailsObject.artist,
        //   [artworkKey]: file.file_id
        // }
      }
    });
    console.log("getters.artistDetails[label_artist_id]",getters.artistDetails[label_artist_id]);

    await MHTTPCL.modify(
      'label_artist_id',
      label_artist_id,
      artworkKey,
      file_id,
      'l_artists'
    );
  },


  async [types.ArtistMetaData.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item,kVal } = payload;
    const { label_artist_id }=item
    //const productObj = getters.productDetails[product_id];

    // console.log({ productOB: productObj });

    //const key = 'product_price_id';
    //const kVal = item[key];
    const table = 'metadata';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }

    NavTabHelper.updateSingleNavTabDetails(label_artist_id, artistDetailsObject => {
      return {
        all_item_metadata: artistDetailsObject.all_item_metadata.map(e => {
          if (e.metadata_id == kVal) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    });

    console.log("METADATA")
    const updatedPriceRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table,
    );

    // console.log(updatedProductDetailsRes.data);
  },

}
